import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const ScheduledMessagesView = () => import('./Index.vue');

const meta = {
  featureFlag: FEATURE_FLAGS.SCHEDULED_MESSAGES,
  permissions: ['administrator', 'agent'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/scheduled-messages'),
      name: 'scheduled_messages_index',
      meta,
      component: ScheduledMessagesView,
    },
  ],
};
